import { render, staticRenderFns } from "./businessNews.vue?vue&type=template&id=46959f4b&scoped=true"
import script from "./businessNews.vue?vue&type=script&lang=js"
export * from "./businessNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46959f4b",
  null
  
)

export default component.exports